
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage-order/[orderNumber]",
      function () {
        return require("private-next-pages/manage-order/[orderNumber].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage-order/[orderNumber]"])
      });
    }
  